<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>

    <div class="container-fluid mt--7">
      <form role="form" v-on:submit="search">
        <div class="search row">
          <div class="dropdown"></div>
          <div class="col-lg-4 pt-0 pl-0 pr-2">
            <base-input
              alternative=""
              label=""
              placeholder="ข้อมูลที่ต้องการค้นหา"
              input-classes="form-control-alternative"
              v-model="keyword"
            />
          </div>
          <input
            type="submit"
            class="btn btn-primary mt--2 mt-md-0 mb-md-4"
            value="ค้นหาข้อมูล"
          />
        </div>
      </form>
      <div class="row">
        <div class="col">
          <document-table
            title="เอกสารทั้งหมด"
            :documents.sync="documents"
            :total.sync="paginate.total"
            :page.sync="paginate.page"
            ref="document_table"
          ></document-table>
          <base-pagination
            :total.sync="paginate.total"
            :perPage="paginate.perPage"
            class="mt-2 d-flex justify-content-end"
            v-model="paginate.page"
          ></base-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DocumentTable from "./Tables/DocumentTable";
import kickMixin from "../mixins/kickMixin";

export default {
  name: "document",
  mixins: [kickMixin],
  components: {
    DocumentTable,
  },
  data() {
    return {
      keyword: "",
      documents: [],
      paginate: {
        total: 0,
        page: 1,
        perPage: 30,
      },
    };
  },
  methods: {
    // loadAllDocument: function() {
    //   var localApp = this;
    //   axios
    //     .get(
    //       "/api/document?page=" + localApp.paginate.page,
    //       {
    //         headers: {
    //           Authorization: "Bearer " + localStorage.token,
    //         },
    //       }
    //     )
    //     .then(function(response) {
    //       localApp.documents = response.data.data.data;
    //       localApp.paginate.total = response.data.data.total;
    //     })
    //     .catch(function() {
    //       localApp.kick();
    //     });
    // },
    search: async function(e) {
      let localApp = this;
      e.preventDefault();
      localApp.$refs.document_table.search(localApp.keyword);
      // await axios
      //   .get(
      //     "/api/document/search/q?keyword=" +
      //       localApp.keyword +
      //       "&page=" +
      //       localApp.paginate.page,
      //     {
      //       headers: {
      //         Authorization: "Bearer " + localStorage.token,
      //       },
      //     }
      //   )
      //   .then(function(response) {
      //     localApp.documents = response.data.data.data;
      //     localApp.paginate.total = response.data.data.total;
      //   })
      //   .catch(function(error) {
      //     alert(error);
      //   });
    },
  },
  // watch: {
  //   "paginate.page": function() {
  //     this.loadAllDocument();
  //   },
  // },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      // this.loadAllDocument();
    }
  },
};
</script>
<style>
.search {
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
a {
  cursor: pointer;
}
</style>
